var _curry2 =
/*#__PURE__*/
require("./_curry2.js");

var _flatCat =
/*#__PURE__*/
require("./_flatCat.js");

var map =
/*#__PURE__*/
require("../map.js");

var _xchain =
/*#__PURE__*/
_curry2(function _xchain(f, xf) {
  return map(f, _flatCat(xf));
});

module.exports = _xchain;